var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    {
      staticClass: "flex-1",
      attrs: { title: _vm.$t("canceled.title"), hasPadding: "" },
    },
    [
      [
        _c(
          "div",
          { staticClass: "flex flex-col gap-2" },
          [
            _c("jade-text", { attrs: { variant: "heading-small" } }, [
              _vm._v("R$ " + _vm._s(_vm.data.value)),
            ]),
            _c(
              "div",
              [
                _c("jade-text", [_vm._v(_vm._s(_vm.computedText.label))]),
                _c("jade-text", [_vm._v(_vm._s(_vm.computedText.percentage))]),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }